import React, { useEffect, useState, useCallback } from "react"
import API from "../../api/axios"
import AdminLayout from "./AdminLayout"

const AdminStudents = () => {
  const [students, setStudents] = useState([])
  const [loading, setLoading]   = useState(true)
  const [error, setError]       = useState("")
  const [search, setSearch]     = useState("")
  const [page, setPage]         = useState(1)
  const [pagination, setPagination] = useState({})

  const fetchStudents = useCallback(async () => {
    setLoading(true)
    try {
      const params = new URLSearchParams({ page, limit: 20 })
      if (search) params.append("search", search)
      const { data } = await API.get(`/users?${params}`)
      setStudents(data.data)
      setPagination(data.pagination || {})
    } catch (err) {
      setError("Failed to load students.")
    } finally { setLoading(false) }
  }, [page, search])

  useEffect(() => { fetchStudents() }, [fetchStudents])

  const handleSearch = (e) => { setSearch(e.target.value); setPage(1) }

  const toggleActive = async (student) => {
    try {
      const { data } = await API.patch(`/users/${student.id}/toggle`)
      setStudents(prev => prev.map(s => s.id === student.id ? data.user : s))
    } catch { setError("Toggle failed.") }
  }

  const fmtDate = (d) => d ? new Date(d).toLocaleDateString("en-KE", { day: "numeric", month: "short", year: "numeric" }) : "-"

  return (
    <AdminLayout title="Students">
      {error && <div className="admin-alert admin-alert-error">{error}</div>}

      <div className="admin-section">
        <div className="admin-section-header">
          <h3>All Students ({pagination.total || 0})</h3>
          <div className="admin-filters">
            <input
              className="admin-search"
              placeholder="Search by name or email…"
              value={search}
              onChange={handleSearch}
            />
          </div>
        </div>

        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Joined</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr className="admin-loading-row">
                  <td colSpan="7"><i className="fa fa-spinner fa-spin"></i> Loading…</td>
                </tr>
              )}
              {!loading && students.length === 0 && (
                <tr><td colSpan="7" className="admin-empty">No students found.</td></tr>
              )}
              {!loading && students.map((s, i) => (
                <tr key={s.id}>
                  <td style={{ color: "#aaa" }}>{(page - 1) * 20 + i + 1}</td>
                  <td>
                    <div style={{ fontWeight: 600 }}>{s.name}</div>
                    {s.avatar && <img src={s.avatar} alt="" style={{ width: 24, height: 24, borderRadius: "50%", marginTop: 3 }} />}
                  </td>
                  <td>{s.email}</td>
                  <td>{s.phone || <span style={{ color: "#ccc" }}>—</span>}</td>
                  <td>{fmtDate(s.createdAt)}</td>
                  <td>
                    <span className={`badge badge-${s.isActive ? "active" : "suspended"}`}>
                      {s.isActive ? "Active" : "Suspended"}
                    </span>
                  </td>
                  <td>
                    <button
                      className={`btn-sm ${s.isActive ? "btn-danger" : "btn-approve"}`}
                      onClick={() => toggleActive(s)}
                    >
                      {s.isActive ? "Suspend" : "Activate"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {pagination.pages > 1 && (
          <div style={{ display: "flex", justifyContent: "center", gap: 8, padding: "16px 20px" }}>
            <button className="btn-sm btn-toggle" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>← Prev</button>
            <span style={{ padding: "5px 12px", fontSize: 13, color: "#666" }}>
              Page {page} of {pagination.pages}
            </span>
            <button className="btn-sm btn-toggle" disabled={page >= pagination.pages} onClick={() => setPage(p => p + 1)}>Next →</button>
          </div>
        )}
      </div>
    </AdminLayout>
  )
}

export default AdminStudents
